import { fetchToken } from "../../common/FetchCookie";
import { BASE_URL, CORE, CORE_INDUSTRY } from "../../common/URLs";

const API_BASE_URL = `${BASE_URL}/${CORE}/${CORE_INDUSTRY}`; // replace with your API base URL

// Fetch All
export const fetchCoreIndustry = async () => {
  const url = `${API_BASE_URL}`;
  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })

    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const data = await response.json();
    return data.response || [];
  } catch (error) {
    console.error("API Error:", error);
    return [];
  }
};

// Add
export const addCoreIndustry = async (newCoreIndustry) => {
  const url = `${API_BASE_URL}`;
  try {
    const token = await fetchToken();

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newCoreIndustry),
    });
    return await response.json();
  } catch (error) {
    console.error("Add error:", error);
    throw error;
  }
};

// Update
export const updateCoreIndustry = async (id, coreIndustryData) => {
  try {
    const token = await fetchToken();

    const response = await fetch(`${API_BASE_URL}/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(coreIndustryData),
    });

    if (!response.ok) throw new Error(`Error updating: ${response.statusText}`);

    return await response.json();
  } catch (error) {
    console.error("Update error:", error);
    throw error;
  }
};

// Delete
export const deleteCoreIndustry = async (id) => {
  try {
    const token = await fetchToken();

    const response = await fetch(`${API_BASE_URL}/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) throw new Error(`Error deleting: ${response.statusText}`);

    return { success: true, id };
  } catch (error) {
    console.error("Delete error:", error);
    throw error;
  }
};
